import { render } from "./edit-client-certificate.vue?vue&type=template&id=2bc173d6"
import script from "./edit-client-certificate.vue?vue&type=script&lang=js"
export * from "./edit-client-certificate.vue?vue&type=script&lang=js"

import "./edit-client-certificate.vue?vue&type=style&index=0&id=2bc173d6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__